import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ReportDefinitionConverter} from './api/entity/converter/reportDefinition.converter';
import {ReportDefinitionSummaryConverter} from './api/entity/converter/reportDefinitionSummary.converter';
import {ReportDefinitionComponentConverter} from './api/entity/converter/reportDefinitionComponent.converter';
import {ReportDefinitionRepository} from './impl/service/ngrx/reportDefinition.repository';
import {ReportDefinitionDataService} from './impl/service/ngrx/reportDefinitionData.service';
import {ReportDefinitionDataServiceAdapter} from './impl/service/ngrx/reportDefinitionDataService.adapter';
import {
    ReportDefinitionSummaryDataServiceAdapter
} from './impl/service/ngrx/reportDefinitionSummaryDataService.adapter';
import {CommunicationContentModelModule} from "../../communication/content-model/communicationContentModel.module";

@NgModule({
    providers: [
        ReportDefinitionConverter,
        ReportDefinitionSummaryConverter,
        ReportDefinitionComponentConverter,
        ReportDefinitionRepository,
        ReportDefinitionDataService,
        ReportDefinitionDataServiceAdapter,
        ReportDefinitionSummaryDataServiceAdapter
    ],
    imports: [
        CommunicationContentModelModule
    ]
})
export class ReportDefinitionModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: ReportDefinitionDataService,
                repository: ReportDefinitionRepository) {

        entityDataService.registerServices({
            ReportDefinition: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ReportDefinition: repository,
        });
    }
}
